<template>
  <div class="software-page">
    <section v-if="contentReady" class="software-hero">
      <div class="software-hero-media">
        <img src="/images/portal-common-software.webp" alt="常用软件">
      </div>

      <div class="software-hero-copy">
        <span class="notes-eyebrow">{{ intro.eyebrow }}</span>
        <h1>{{ intro.title }}</h1>
        <p v-if="intro.description">{{ intro.description }}</p>
        <div v-if="intro.tags.length" class="notes-hero-meta">
          <span v-for="tag in intro.tags" :key="tag">{{ tag }}</span>
        </div>
      </div>
    </section>

    <section class="software-toolbar">
      <div>
        <strong>{{ sortedSoftwareLinks.length }}</strong>
        <span>个软件下载入口</span>
      </div>
      <RouterLink class="notes-toolbar-link" to="/">
        返回首页
      </RouterLink>
    </section>

    <section class="software-grid">
      <div v-if="!contentReady" class="notes-empty-state">
        <h2>内容加载中</h2>
        <p>正在从本地后台同步常用软件列表，请稍等一下。</p>
      </div>

      <div v-else-if="!sortedSoftwareLinks.length" class="notes-empty-state">
        <h2>这里还没有软件</h2>
        <p>进入后台新增软件 Logo、名称和下载网址后，这里会生成可点击的软件卡片。</p>
      </div>

      <a
        v-else
        v-for="software in sortedSoftwareLinks"
        :key="software.id"
        class="software-card"
        :data-software-name="software.name"
        :href="software.url || '#'"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="`打开 ${software.name}`"
        :class="{ 'is-disabled': !software.url || !canOpenSoftware(software) }"
        @click="handleSoftwareClick($event, software)"
      >
        <span class="software-logo-frame">
          <img
            v-if="software.logo"
            :src="software.logo"
            :alt="software.name"
          >
          <span v-else>{{ getInitial(software.name) }}</span>
        </span>
        <strong>{{ software.name }}</strong>
      </a>
    </section>
  </div>
</template>

<script setup>
import { computed, watchEffect } from "vue";
import { RouterLink } from "vue-router";
import { useContentStore } from "@/store/contentStore";
import { useAuthStore } from "@/store/authStore";
import { sortSoftwareLinksByName } from "@/utils/softwareSort";

const { softwareLinks, moduleIntros, contentReady } = useContentStore();
const { isLoggedIn } = useAuthStore();

const intro = computed(() => moduleIntros.value.commonSoftware);
const sortedSoftwareLinks = computed(() => sortSoftwareLinksByName(softwareLinks.value));

const getInitial = (name = "") => String(name || "软").trim().slice(0, 1).toUpperCase();

const canOpenSoftware = (software = {}) =>
  software.isPublic !== false || isLoggedIn.value;

const handleSoftwareClick = (event, software) => {
  if (!canOpenSoftware(software)) {
    event.preventDefault();
    window.alert("请登录");
    return;
  }

  if (!software.url) {
    event.preventDefault();
  }
};

watchEffect(() => {
  document.title = "圣域空间 | 常用软件";
});
</script>
